// The nearest Card's title, for primitives that need a human name without a
// prop: ChartFrame uses it as the heading of its full-screen view ("Cycling
// intensity") and for the Expand button's accessible label. Null outside a
// Card or when the title is not plain text.

import { createContext, useContext } from "react";

export const CardTitleContext = createContext<string | null>(null);

export function useCardTitle(): string | null {
  return useContext(CardTitleContext);
}
